import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"

//i18n
import { withTranslation } from "react-i18next"
import SidebarContent from "./SidebarContent"

const Sidebar = props => {
  return (
    <React.Fragment>
      <div className="vertical-menu">
        {/* Logo at top of sidebar - Donezo Style */}
        {/* <div className="modern-sidebar-logo">
          <Link to="/" className="donezo-logo-link">
            <img src="/logo.svg" alt="GOVCOM" className="donezo-logo-img" />
            <span className="donezo-logo-text">GOVCOM</span>
          </Link>
        </div> */}
  <div className="modern-sidebar-logo">
  <Link to="/" className="donezo-logo-link">
    <img 
      src="/images/Logo_low.png" 
      alt="GOVCOM" 
      // className="donezo-logo-img h-10 w-auto"
    />
    {/* <span className="donezo-logo-text">GOVCOM</span> */}
  </Link>
</div>
        {/* Sidebar content */}
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
      </div>
    </React.Fragment>
  )
}

Sidebar.propTypes = {
  type: PropTypes.string,
}

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  }
}
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)))
